export default "__VITE_ASSET__BGjk2q6j__"